import { render, staticRenderFns } from "./BatchAsinMskuCards.vue?vue&type=template&id=61865689&scoped=true"
import script from "./BatchAsinMskuCards.vue?vue&type=script&lang=js"
export * from "./BatchAsinMskuCards.vue?vue&type=script&lang=js"
import style0 from "./BatchAsinMskuCards.vue?vue&type=style&index=0&id=61865689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61865689",
  null
  
)

export default component.exports